export default __webpack_public_path__ + "static/media/cross.45cbf5cb.svg";